import * as Dialog from '@studio/design-system/dialog';
import type { Credentials as M_Credentials } from '@studio/models/auth';
import type { ReactElement, ReactNode } from 'react';
import { DestinationForm } from './form.js';
import { DestinationHeader } from './header.js';

interface RTMPDestinationPanelProps {
  isOpen: boolean;
  onClose: (open: boolean) => void;
  nickname: string;
  setNickname: (nickname: string) => void;
  server: string;
  setServer: (server: string) => void;
  streamKey: string;
  setStreamKey: (streamKey: string) => void;
  requireAuth: boolean;
  setRequireAuth: (requireAuth: boolean) => void;
  credentials: M_Credentials | undefined;
  setCredentials: (credentials: M_Credentials | undefined) => void;
  errors: Record<string, string>;
  FooterComponent: ReactNode;
}

export const DestinationPanel = ({
  isOpen,
  onClose,
  nickname,
  setNickname,
  server,
  setServer,
  streamKey,
  setStreamKey,
  requireAuth,
  setRequireAuth,
  credentials,
  setCredentials,
  errors,
  FooterComponent
}: RTMPDestinationPanelProps): ReactElement => {
  return (
    <Dialog.Root open={isOpen}>
      <Dialog.Overlay className='z-100'>
        <Dialog.Sheet className='w-sheet text-white'>
          <div className='relative flex h-full w-full flex-col p-8 text-white'>
            <DestinationHeader onClose={onClose} />
            <DestinationForm
              nickname={nickname}
              setNickname={setNickname}
              server={server}
              setServer={setServer}
              streamKey={streamKey}
              setStreamKey={setStreamKey}
              requireAuth={requireAuth}
              setRequireAuth={setRequireAuth}
              credentials={credentials}
              setCredentials={setCredentials}
              errors={errors}
            />
          </div>
          {FooterComponent}
        </Dialog.Sheet>
      </Dialog.Overlay>
    </Dialog.Root>
  );
};
